const MINUTE = 1000 * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export function granularityFormatter(millis) {
    if (!millis) return 'Invalid granularity';
    if (millis < MINUTE) return '< 1 minute granularity';
    if (millis === MINUTE) return '1 minute granularity';
    if (millis < HOUR) return `${(millis / MINUTE).toFixed(0)} minute granularity`;
    if (millis === HOUR) return '1 hour granularity';
    if (millis < DAY) return `${(millis / HOUR).toFixed(0)} hour granularity`;
    if (millis === DAY) return '1 day granularity';
    return `${(millis / DAY).toFixed(0)} day granularity`;
}
